// extracted by mini-css-extract-plugin
export default {"feedback":"TypeformEmbed_feedback__FAXmD"};